import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=631cc263&"
import script from "./CommentInput.vue?vue&type=script&lang=ts&"
export * from "./CommentInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports